<template>
  <div class="PageGuard">
    <PageHeaderMobile :pageHeaderTitle="pageHeaderTitle" @goBack="goBack"></PageHeaderMobile>
    <Tabs :tabsData="tabsData" :active="activeTab" @tabClick="getActiveTab">
      <div slot="tab1">
        <CardTable>
          <div class="card-item">
            <div class="label">SO</div>
            <div class="value">{{ reserveData.SO }}</div>
          </div>
        </CardTable>
        <CardTable v-for="(item, index) in reserveData.data" :key="index">
          <div class="card-item">
            <div class="label">SO Line</div>
            <div class="value">{{ item.SOLine }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.area") }}</div>
            <div class="value">{{ item.area }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.partNo") }}</div>
            <div class="value">{{ item.partNo }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.partName") }}</div>
            <div class="value">{{ displayPartName(getLanguage(), item.partNameCN, item.partName) }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.grossWeight") }}</div>
            <div class="value">{{ item.grossWeight }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.packType") }}</div>
            <div class="value">{{ $store.getters.getSysCodeText("packType", item.packType) }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.packNumber") }}</div>
            <div class="value">{{ item.packNumber }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.packWeight") }}</div>
            <div class="value">{{ item.packWeight }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.netWeight") }}</div>
            <div class="value">{{ item.netWeight }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.unit") }}</div>
            <div class="value">{{ item.unit }}</div>
          </div>
          <div class="card-item">
            <div class="label">Plant Code</div>
            <div class="value">{{ item.plantCode }}</div>
          </div>
        </CardTable>
      </div>
      <div slot="tab2">
        <CardTable>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.departuretime") }}</div>
            <div class="value">{{ leaveDateTime ?? "" }}</div>
          </div>
          <div class="card-item">
            <ApprovalProgressIndicator :progressData="approvalProgressData"></ApprovalProgressIndicator>
          </div>
        </CardTable>
      </div>
    </Tabs>
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import { mapGetters } from "vuex"
import PageHeaderMobile from "@/components/common/PageHeaderMobile.vue"
import CardTable from "@/components/common/CardTable.vue"
import Tabs from "@/components/common/Tabs.vue"
import ApprovalProgressIndicator from "@/components/common/ApprovalProgressIndicator.vue"

export default {
  name: "PageGuardReservationReleaseInfo",
  props: {
    leaveDateTime: {
      type: String,
    },
    reserveData: {
      type: Object,
    },
  },
  components: {
    PageHeaderMobile,
    CardTable,
    Tabs,
    ApprovalProgressIndicator,
  },
  data() {
    return {
      pageHeaderTitle: this.reserveData.releaseOrderNo,
      activeTab: "tab1",
      tabsData: [
        {
          name: "tab1",
          label: this.$t("pages.wording.releaseDetail"),
        },
        {
          name: "tab2",
          label: this.$t("pages.wording.approvalRecords"),
        },
      ],
      reserveSOList: [],
      approvalProgressData: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getLanguage"]),
    init() {
      this.getSignTable()
    },
    displayPartName(lang, chName, enName) {
      return utils.displayPartName(utils.displayCHName(lang), chName, enName)
    },
    goBack() {
      this.$router.go(-1)
    },
    getActiveTab(val) {
      this.activeTab = val
    },
    getSignTable() {
      let vueInstance = this
      let params = { releaseId: vueInstance.reserveData.releaseID }
      api
        .apiGetSignTable(params)
        .then((response) => {
          if (response.data.success) {
            vueInstance.approvalProgressData = response.data.result
            vueInstance.approvalProgressData.forEach((item) => {
              let hasApproval = item.signDatetime === null
              item.state = hasApproval
                ? vueInstance.$t("pages.wording.waitForApproval")
                : vueInstance.$t("pages.wording.approve")
              item.member = item.signUserName
              item.role = vueInstance.$t("role." + item.signRole)
              item.datetime = utils.parseISOStringToDateTime(item.signDatetime)
              item.isActive = hasApproval
              if (item.signUserID === null) {
                if (vueInstance.getUserRoles().includes(item.signRole)) {
                  vueInstance.roleNotYetSign = true
                  return
                }
              }
            })
          }
        })
        .catch(function (e) {
          console.log(e)
        })
    },
  },
}
</script>
<style scoped>
.PageGuard {
  margin: 0 -20px -20px -20px;
  padding-top: 20px;
}

#pane-tab1 .CardTable:not(:last-child) {
  margin-bottom: 8px;
}
</style>
